import { ReactNode } from 'react';
import { clsx } from 'clsx';

export function Card({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={clsx('bg-card rounded-xl shadow-md p-6 transition-all', className)}>{children}</div>
  );
}
